import { Component } from '@angular/core'
import { ADN_PLUS } from '../../models';
import { InputBaseComponent } from '../input-base.component';

@Component({
  selector: 'ct-label',
  templateUrl: './ct-label.component.html',
  styleUrls: ['./ct-label.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()',
    '[class]': 'getStyleClass()',
    '[style]': 'getCustomCss()'
  }
})
export class CtLabelComponent extends InputBaseComponent {

  private labelPrefixValue: string;
  private icon: string;
  private textWhenNull: string = '(no definido)';

  constructor() {
    super();
  }

  getValue(): string { return super.getLabelValue() }
  setValue(value: any): void {
    if (this.getModelId()) {
      if (value instanceof ADN_PLUS)
        this.setLabelValue(value.getStringAttribute(this.getModelId()) ? value.getStringAttribute(this.getModelId()) : this.getTextWhenNull());
      else if (typeof (value) === 'string')
        this.setLabelValue(value && value !== 'null' ? value : this.getTextWhenNull());
      else
        this.setLabelValue(this.getTextWhenNull());
    }
  }

  setIcon(icon: string): void { this.icon = icon }
  getIcon(): string { return this.icon }
  getTextWhenNull(): string { return this.textWhenNull }
  getLabelValue(): string {
    return super.getLabelValue().replaceAll('\n', '</br></br>');
  }

  getPrefixLabelValue() { return this.labelPrefixValue }
  setPrefixLabelValue(labelPrefixValue: string) { this.labelPrefixValue = labelPrefixValue };
  setTextWhenNull(textWhenNull: string) { this.textWhenNull = textWhenNull };

}
